import { render, staticRenderFns } from "./BookingPay.vue?vue&type=template&id=1d81ac85&scoped=true"
import script from "./BookingPay.vue?vue&type=script&lang=ts"
export * from "./BookingPay.vue?vue&type=script&lang=ts"
import style0 from "./BookingPay.vue?vue&type=style&index=0&id=1d81ac85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d81ac85",
  null
  
)

export default component.exports